import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@services/user.service';
import { PRIMENG_MODULES } from '@shared/primeng';
import { QRCodeComponent } from 'angularx-qrcode';
import {
	QrScannerComponent,
	ScannerOutput,
} from '../qr-scanner/qr-scanner.component';
import { QrService } from '@services/qr.service';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
	selector: 'app-global-qr',
	imports: [
		CommonModule,
		QRCodeComponent,
		QrScannerComponent,
		...PRIMENG_MODULES,
	],
	templateUrl: './global-qr.component.html',
	styleUrl: './global-qr.component.scss',
})
export class GlobalQrComponent implements OnInit, OnDestroy {
	private readonly qrService = inject(QrService);
	private readonly router = inject(Router);
	public readonly userService = inject(UserService);

	private readonly unsubscribe$ = new Subject<void>();

	public user = this.userService.user();
	public qrData = this.userService.getUserQRData();
	public showQRCode = false;
	public scanQRCode = false;
	public qrLabel = '';

	ngOnInit(): void {
		this.userService.closeAllDialogs$
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(() => {
				this.showQRCode = false;
				this.scanQRCode = false;
			});

		this.qrLabel =
			this.user?.role === 'user' ? 'Mostrá tu CapyQR' : 'Escanear QR';
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public openDialog(): void {
		if (!this.user) return;

		this.router.navigate(['/home']);

		if (!this.user.role || this.user.role === 'user') {
			this.showQRCode = true;
			return;
		}

		this.scanQRCode = true;
	}

	public async onScannedQR(event: ScannerOutput): Promise<void> {
		console.log({ event });

		this.scanQRCode = false;
		await this.qrService.handleQRCode(event);
	}
}
